import { Table, Text } from '@nimbus-ds/components';
import { ProductTransferDetailsResponseDto } from '@tiendanube/common';
import { extractTransferProductDetails } from 'domains/Catalog/Transfers/utils';
import {
  TransferHeaderCells,
  TransferProductCell,
  TransferVariantCell,
} from './components';
import { TransferDetailStatus } from '../../../components';

type ProductVariant =
  ProductTransferDetailsResponseDto['productVariants'][number];

interface TransferTableProps {
  productVariants: ProductVariant[];
}

function TransferTable({ productVariants }: Readonly<TransferTableProps>) {
  const selectedProducts = extractTransferProductDetails(productVariants);

  const renderQuantityDone = (variant: ProductVariant) => (
    <Text>{variant.quantityDone}</Text>
  );

  if (productVariants.length === 0) {
    return null;
  }

  return (
    <Table>
      <Table.Head>
        <TransferHeaderCells />
      </Table.Head>
      <Table.Body>
        {selectedProducts.map((product) => (
          <Table.Row key={`${product.productId}`}>
            <Table.Cell>
              <TransferProductCell product={product} />
            </Table.Cell>
            <TransferVariantCell
              productId={product.productId}
              productVariants={productVariants}
              renderProp={(variant: ProductVariant) => (
                <Text>{variant.variantName}</Text>
              )}
            />
            <TransferVariantCell
              productId={product.productId}
              productVariants={productVariants}
              renderProp={({ quantity }) => <Text>{quantity}</Text>}
            />
            <TransferVariantCell
              productId={product.productId}
              productVariants={productVariants}
              renderProp={renderQuantityDone}
            />
            <TransferVariantCell
              productId={product.productId}
              productVariants={productVariants}
              renderProp={(variant: ProductVariant) => (
                <TransferDetailStatus
                  status={variant.status}
                  isPartial={variant.quantityDone < variant.quantity}
                />
              )}
            />
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  );
}

export default TransferTable;
